import { render, staticRenderFns } from "./LoadingSection.vue?vue&type=template&id=a373dcee&"
import script from "./LoadingSection.vue?vue&type=script&lang=ts&"
export * from "./LoadingSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports